const disconnectors = new Set<() => void>();

export const sseRegistry = {
  register(disconnect: () => void): () => void {
    disconnectors.add(disconnect);
    return () => disconnectors.delete(disconnect);
  },
  disconnectAll() {
    disconnectors.forEach((fn) => fn());
  }
};
